import { rankList, threads } from "@/mocks/home";

export default function RankCommunity() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        {/* ===== 热榜 ===== */}
        <div id="hot" className="lg:col-span-5 scroll-mt-24">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-fire-fill"></i>
              </span>
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">吃瓜热榜</h2>
                <p className="text-xs text-foreground-500 mt-1">实时热度排序 · 每 10 分钟刷新</p>
              </div>
            </div>
            <span className="hidden md:inline-flex items-center gap-1 rounded-full bg-background-100 text-foreground-500 px-3 py-1 text-xs whitespace-nowrap">
              <i className="ri-time-line"></i> 更新于 09:30
            </span>
          </div>

          <div className="rounded-lg border border-background-200/60 bg-background-50 overflow-hidden divide-y divide-background-100">
            {rankList.map((r) => (
              <div key={r.rank} className="group flex items-center gap-3 px-4 py-3 hover:bg-background-100/60 transition cursor-pointer">
                <span
                  className={`w-7 h-7 shrink-0 rounded-md text-center leading-7 text-sm font-black ${
                    r.rank <= 3 ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-600"
                  }`}
                >
                  {r.rank}
                </span>
                <p className="flex-1 text-sm md:text-[15px] font-medium text-foreground-800 group-hover:text-primary-700 truncate">
                  {r.name}
                </p>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="text-sm font-bold text-foreground-950">{r.heat}</span>
                  <span
                    className={`inline-flex items-center gap-0.5 text-xs w-8 justify-end ${
                      r.delta > 0 ? "text-primary-600" : r.delta < 0 ? "text-secondary-500" : "text-foreground-300"
                    }`}
                  >
                    {r.delta > 0 && (<><i className="ri-arrow-up-line"></i>{r.delta}</>)}
                    {r.delta < 0 && (<><i className="ri-arrow-down-line"></i>{Math.abs(r.delta)}</>)}
                    {r.delta === 0 && <i className="ri-subtract-line"></i>}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-3 text-xs text-foreground-400 flex items-center gap-1.5">
            <i className="ri-question-line"></i> 热度综合讨论量与增长趋势得出，仅供参考。
          </p>
        </div>

        {/* ===== 社区讨论区 ===== */}
        <div id="community" className="lg:col-span-7 scroll-mt-24">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-group-2-line"></i>
              </span>
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">围观台 · 讨论区</h2>
                <p className="text-xs text-foreground-500 mt-1">把时间线捋直，把判断权交给你</p>
              </div>
            </div>
            <button
              type="button"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-3.5 py-2 text-sm font-semibold hover:bg-primary-600 transition whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-2-line"></i> 开个新话题
            </button>
          </div>

          <div className="space-y-4">
            {threads.map((t, idx) => (
              <article key={t.title} className="rounded-lg border border-background-200/60 bg-background-50 p-4 md:p-5 hover:border-secondary-300 transition">
                <div className="flex items-start gap-3.5">
                  <span
                    className={`w-10 h-10 shrink-0 rounded-full flex items-center justify-center text-sm font-black text-background-50 ${
                      idx % 3 === 0 ? "bg-primary-500" : idx % 3 === 1 ? "bg-accent-600" : "bg-secondary-600"
                    }`}
                  >
                    {t.author.slice(0, 1)}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="rounded-md bg-accent-100 text-accent-900 px-2 py-0.5 text-xs font-semibold whitespace-nowrap">{t.topic}</span>
                      {t.tags.map((tag) => (
                        <span key={tag} className="rounded-md bg-background-100 text-foreground-500 px-2 py-0.5 text-xs whitespace-nowrap">{tag}</span>
                      ))}
                    </div>
                    <h3 className="mt-2 text-[15px] md:text-base font-bold leading-snug text-foreground-950 hover:text-primary-700 transition cursor-pointer">
                      {t.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500">楼主 · {t.author}</p>

                    {/* 站队投票 */}
                    <div className="mt-3 rounded-md bg-background-100/60 border border-background-200/50 p-3">
                      <div className="flex items-center text-xs font-medium text-foreground-700">
                        <span className="flex-1 truncate pr-2">👍 {t.voteA}</span>
                        <span className="text-primary-700 font-bold">{t.ratioA}%</span>
                      </div>
                      <div className="mt-2 h-2 rounded-full bg-background-200 overflow-hidden flex">
                        <span className="h-full bg-primary-400" style={{ width: `${t.ratioA}%` }}></span>
                        <span className="h-full flex-1 bg-background-300"></span>
                      </div>
                      <div className="mt-2 flex items-center text-xs font-medium text-foreground-700">
                        <span className="flex-1 truncate pr-2">👎 {t.voteB}</span>
                        <span className="text-foreground-500 font-bold">{100 - t.ratioA}%</span>
                      </div>
                    </div>

                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400 flex-wrap">
                      <span className="inline-flex items-center gap-1"><i className="ri-reply-line"></i> 回复 {t.replies}</span>
                      <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i> {t.views}</span>
                      <button
                        type="button"
                        className="ml-auto inline-flex items-center gap-1.5 rounded-full border border-background-200/70 px-3 py-1 text-xs font-semibold text-foreground-700 hover:border-secondary-300 hover:text-secondary-900 transition whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-thumb-up-line"></i> 点赞
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-lg bg-background-100/60 border border-background-200/50 px-4 py-3.5">
            <p className="text-sm text-foreground-600 flex items-center gap-2">
              <i className="ri-chat-smile-2-line text-accent-500"></i>
              本周围观台共新增讨论 2.3w 条，最热帖 1.2 小时破千楼。
            </p>
            <button
              type="button"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
            >
              查看更多帖子 <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}